import { Component, OnInit, OnDestroy, Input, Inject, ChangeDetectionStrategy } from '@angular/core';



import { ActivatedRoute } from '@angular/router';

import { AuthService } from '../../../services/auth/auth.service';

import { ChatRoomService } from '../../../services/chatmessageservice/chatroom.service';
import { Router } from '@angular/router';

import { forkJoin, Subscription } from 'rxjs';



import { FormInvite, Invite } from '../../../bo9-shared/models/person/invite.model';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Person } from '../../../bo9-shared/models/person/person.model';
import { ArangoService } from '../../../services/arangoservice/arango.service';

@Component({
    selector: 'app-dialog-invite',
    templateUrl: './inviteDialog.component.html',
    styleUrls: ['./inviteDialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class InviteDialogComponent implements OnInit  {
  disableBtn = false;
  user: Person;
  subscriptions: Subscription[] = [];
  constructor(
    private dialogRef: MatDialogRef<InviteDialogComponent>,
    @Inject(MAT_DIALOG_DATA)  public data: { invite: Invite } ,

    private route: ActivatedRoute,
    private auth: AuthService,

    private arangoService: ArangoService,
    private router: Router,



   ) {
      console.log ('Init invite ' + JSON.stringify(data));
      this.user = this.auth.getAuthUser()!;
      this.subscriptions.forEach(s => s.unsubscribe());
      this.subscriptions.push(this.arangoService.recordVisit({
        page: this.router.url, component: 'InviteDialogComponent', 
        visitor: this.user._key,
        help: false
      }).subscribe ({next: () => {}})); 
     }

  ngOnInit() {

    console.log ('Init invite init ' + JSON.stringify(this.data));
    this.user = this.auth.getAuthUser()!;

    if (!this.user) {
      console.error('User Not logged in ');
      alert('EMail support&#64;bodyof9.com - Permission  Error #005'); 
      this.router.navigate(['login'] );
    }

  }


  deleteSelectInvite(p: Invite ) {
    this.dialogRef.close(p);
  }

  close() {
    this.dialogRef.close();
  }
}
